import { render, staticRenderFns } from "./server-list.vue?vue&type=template&id=4fe8c774&scoped=true&"
import script from "./server-list.vue?vue&type=script&lang=js&"
export * from "./server-list.vue?vue&type=script&lang=js&"
import style0 from "./server-list.vue?vue&type=style&index=0&id=4fe8c774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe8c774",
  null
  
)

export default component.exports